// eslint-disable-next-line jsx-a11y/label-has-associated-control
/* eslint-disable react/jsx-curly-newline */
/* eslint-disable */
import { AlertAdapter, RegularButton, CommonDropdown, CommonInput, ICommonDropdownOption } from 'pg-ui-library';
import React, { useEffect } from 'react';
import ReactModal from 'react-modal';
import { useTranslation } from 'react-i18next';
import { CloseIcon } from 'src/modules/login/components/mfa-modal/styles';
import closeSvg from 'src/assets/close.svg';
import { useFormik } from 'formik';
import attachmentBlue from 'src/assets/attachment-blue.svg';
import { useLeaveUpdate } from '../mutations/leave-update';

import {
  ReopenTicketForm,
  LeaveModalConfimrationHeader,
  ReopenFooter,
  LeaveRequestDetail,
  FormInputWrapper,
  ActionCommomdropdown,
} from './styles';

const leaveAction: ICommonDropdownOption[] = [
  {
    key: '1',
    label: 'Pending',
    value: 'Pending',
  },
  {
    key: '2',
    label: 'Approve',
    value: 'Approved',
  },
  {
    key: '3',
    label: 'Reject',
    value: 'Rejected',
  },
];

export const LeaveDeatilModal: React.FC<{
  isOpenDetail: boolean;
  setIsOpenDetail: React.Dispatch<React.SetStateAction<boolean>>;
  leaveSend: any;
  refetch: any;
  setSelectedRows: any;
}> = ({ isOpenDetail, setIsOpenDetail, leaveSend, refetch, setSelectedRows }) => {
  const { t } = useTranslation();
  const leaveUpdateSubmit = useLeaveUpdate();
  const leaveId = leaveSend?.id;

  const leaveHours = leaveSend?.hours;
  const leaveLength = leaveSend?.length;

  console.log('Leave', leaveSend);

  const handleModal = () => {
    setIsOpenDetail(prevState => !prevState);
  };
  const formik = useFormik({
    initialValues: {
      employeeName: '',
      personnelNumber: '',
      companyId: '',
      accrualName: '',
      startDate: '',
      hours: '',
      length: '',
      endDate: '',
      reason: '',
      comment: '',
      status: leaveSend?.status || '',
      attachments: [],
    },
    onSubmit: async (values: any) => {
      await leaveUpdateSubmit.mutateAsync({ leaveId, leaveUpdate: values });
      AlertAdapter('Leave status is change succesfully', 'success');
      refetch();
      setIsOpenDetail(!isOpenDetail);
      setSelectedRows([]);
    },
  });

  useEffect(() => {
    if (
      leaveSend &&
      (formik.values.employeeName !== leaveSend?.employeeName ||
        formik.values.personnelNumber !== leaveSend?.personnelNumber ||
        formik.values.companyId !== leaveSend?.companyId ||
        formik.values.accrualName !== leaveSend?.accrualName ||
        formik.values.hours !== leaveSend?.hours ||
        formik.values.length !== leaveSend?.length ||
        formik.values.startDate !== leaveSend?.startDate ||
        formik.values.endDate !== leaveSend?.endDate ||
        formik.values.reason !== leaveSend?.reason ||
        formik.values.status !== leaveSend?.status ||
        formik.values.comment !== leaveSend?.comment)
    ) {
      formik.setValues({
        employeeName: leaveSend?.employeeName || '',
        personnelNumber: leaveSend?.personnelNumber || '',
        companyId: leaveSend?.companyId || '',
        accrualName: leaveSend?.accrualName || '',
        startDate: leaveSend?.startDate || '',
        endDate: leaveSend?.endDate || '',
        hours: leaveSend?.hours || '',
        length: leaveSend?.length || '',
        reason: leaveSend?.reason || '',
        status: leaveSend?.status || '',
        comment: leaveSend?.comment || '',
        attachments: leaveSend?.attachments || [],
      });
    }
  }, [leaveSend]);

  const handleDropdownChange = (value: string) => {
    formik.setFieldValue('status', value);
  };

  return (
    <ReactModal
      isOpen={isOpenDetail}
      ariaHideApp={false}
      onRequestClose={handleModal}
      style={{
        overlay: {
          margin: 'auto',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
        },
        content: {
          borderRadius: '30px',
          margin: 'auto',
          width: '920px',
          height: '720px',
          display: 'flex',
          flexDirection: 'column',
          padding: '0 20px 0 20px',
          background: '#F3F4F8',
          overflowY: 'hidden',
        },
      }}
    >
      <ReopenTicketForm onSubmit={formik.handleSubmit}>
        <LeaveModalConfimrationHeader>
          <div>
            <h3>Leave Detail ({leaveSend?.leaveRequestId})</h3>
          </div>
          <div style={{ marginTop: '30px' }}>
            <CloseIcon src={closeSvg} onClick={() => handleModal()} />
          </div>
        </LeaveModalConfimrationHeader>

        <LeaveRequestDetail>
          <FormInputWrapper style={{ flex: '1 0 calc(30% - 10px)' }}>
            <CommonInput
              id="employeeName"
              name="employeeName"
              label="Employee"
              placeholder="Employee Name"
              value={formik.values.employeeName}
              onChange={event => formik.setFieldValue('employeeName', event.target.value)}
              style={{ width: '100%' }}
              disabled
            />
          </FormInputWrapper>

          <FormInputWrapper style={{ flex: '1 0 calc(30% - 10px)' }}>
            <CommonInput
              id="personnelNumber"
              name="personnelNumber"
              label="Personnel Number"
              placeholder="Personnel Number"
              value={formik.values.personnelNumber}
              onChange={event => formik.setFieldValue('personnelNumber', event.target.value)}
              style={{ width: '100%' }}
              disabled
            />
          </FormInputWrapper>

          <FormInputWrapper style={{ flex: '1 0 calc(30% - 10px)' }}>
            <CommonInput
              id="companyId"
              name="companyId"
              label="Company ID"
              placeholder="Company ID"
              value={formik.values.companyId}
              onChange={event => formik.setFieldValue('companyId', event.target.value)}
              style={{ width: '100%' }}
              disabled
            />
          </FormInputWrapper>

          <FormInputWrapper style={{ flex: '1 0 calc(30% - 10px)' }}>
            <CommonInput
              id="accrualName"
              name="accrualName"
              label="Leave Type"
              placeholder="Leave Type"
              value={formik.values.accrualName}
              onChange={event => formik.setFieldValue('accrualName', event.target.value)}
              style={{ width: '100%' }}
              disabled
            />
          </FormInputWrapper>

          <FormInputWrapper style={{ flex: '1 0 calc(30% - 10px)' }}>
            <CommonInput
              id="startDate"
              name="startDate"
              label="Start Date"
              placeholder="Start Date"
              value={formik.values.startDate}
              onChange={event => formik.setFieldValue('startDate', event.target.value)}
              style={{ width: '100%' }}
              disabled
            />
          </FormInputWrapper>

          <FormInputWrapper style={{ flex: '1 0 calc(30% - 10px)' }}>
            <CommonInput
              id="endDate"
              name="endDate"
              label="End Date"
              placeholder="End Date"
              value={formik.values.endDate}
              onChange={event => formik.setFieldValue('endDate', event.target.value)}
              style={{ width: '100%' }}
              disabled
            />
          </FormInputWrapper>

          <FormInputWrapper style={{ flex: '1 0 calc(30% - 10px)' }}>
            <CommonInput
              id="length"
              name="length"
              label="Leave Days"
              placeholder="Leave Days"
              value={formik.values.length}
              onChange={event => formik.setFieldValue('length', event.target.value)}
              style={{ width: '100%' }}
              disabled
            />
          </FormInputWrapper>

          <FormInputWrapper style={{ flex: '1 0 calc(30% - 10px)' }}>
            <CommonInput
              id="hours"
              name="hours"
              label="Leave Hours"
              placeholder="Leave Hours"
              value={formik.values.hours}
              onChange={event => formik.setFieldValue('hours', event.target.value)}
              style={{ width: '100%' }}
              disabled
            />
          </FormInputWrapper>

          <FormInputWrapper style={{ flex: '1 0 calc(32% - 10px)', marginLeft: '10px' }}>
            <CommonDropdown
              label="Status"
              id="status"
              name="status"
              options={leaveAction}
              value={formik.values.status}
              setValue={handleDropdownChange}
              selectStyle={{
                width: '100%',
                marginRight: '10px',
                backgroundColor: '#4948ac',
                color: 'white',
                border: '1px solid #ccc',
                borderRadius: '4px',
              }}
            />
          </FormInputWrapper>

          <ActionCommomdropdown style={{ flex: '1 0 calc(100% - 10px)' }}>
            <label style={{ display: 'block', marginBottom: '5px' }}>Reason for Leave</label>
            <textarea
              id="reason"
              name="reason"
              placeholder="Enter the reason for leave"
              value={formik.values.reason}
              onChange={event => formik.setFieldValue('reason', event.target.value)}
              style={{
                width: '100%',
                height: '80px',
                borderRadius: '7px',
                border: '1px solid #ccc',
                padding: '5px',
              }}
              disabled
            />
          </ActionCommomdropdown>

          <FormInputWrapper style={{ flex: '1 0 calc(40% - 10px)' }}>
            <label style={{ display: 'block', marginBottom: '5px' }}>Attachments</label>

            <div>
              <p>
                {formik.values.attachments && formik.values.attachments.length > 0 && (
                  <img
                    src={attachmentBlue}
                    alt="Formatting Icon"
                    style={{ height: '17px', margin: '0px 10px 0px 2px' }}
                  />
                )}
                {formik.values.attachments.map((attachment: any, index: any) => (
                  <React.Fragment key={index}>
                    <a href={attachment.attachmentUrl} target="_blank" rel="noopener noreferrer">
                      {attachment.attachmentName}
                    </a>
                    {index < formik.values.attachments.length - 1 && ', '}
                  </React.Fragment>
                ))}
              </p>
            </div>
          </FormInputWrapper>

          <FormInputWrapper style={{ flex: '1 0 calc(40% - 10px)' }}>
            <label style={{ display: 'block', marginBottom: '5px' }}>Comment</label>
            <textarea
              id="comment"
              name="comment"
              placeholder="Enter the comment for leave"
              value={formik.values.comment}
              onChange={event => formik.setFieldValue('comment', event.target.value)}
              style={{
                width: '100%',
                height: '80px',
                borderRadius: '7px',
                border: '1px solid #ccc',
                padding: '5px',
              }}
            />
          </FormInputWrapper>
        </LeaveRequestDetail>

        <ReopenFooter>
          <RegularButton
            disabled={formik.isSubmitting}
            type="submit"
            style={{ color: '#4948AC', backgroundColor: '#fff' }}
            onClick={() => setIsOpenDetail(!isOpenDetail)}
          >
            {t('global.form.cancel')}
          </RegularButton>
          <RegularButton disabled={formik.isSubmitting} type="submit">
            Save
          </RegularButton>
        </ReopenFooter>
      </ReopenTicketForm>
    </ReactModal>
  );
};
